import React, {
	Component,
	Fragment
} from "react";
import '../styles/App.css';
import { withTranslation } from "react-i18next";
import hoistStatics from 'hoist-non-react-statics';

const defaultDots = {
	default: [0, 0, 0, 0, 0, 0],
	euro: [0, 0, 0, 0, 0, 0, 0, 0]
};
const lang = {
	dot: "Punkt ",
	empty: "Leeres Zeichen",
	on: "ein",
	off: "aus",
	prefix: {
		1: "Erstes Zeichen: ",
		2: "Zweites Zeichen: ",
		3: "Drittes Zeichen: ",
	},
};

class BrailleCharacter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			numeric: 0,
			isReading: true,
			isPartOfMultipleCharacter: false,
			characterIndex: 1,
			isEuroBraille: false,
			dots: [],
		};
	}

	pad(str, width, z) {
		z = z || "0";
		return str.length >= width
			? str
			: new Array(width - str.length + 1).join(z) + str;
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState(
			{
				isReading: nextProps.isReading,
				isPartOfMultipleCharacter: this.props.isPartOfMultipleCharacter,
				characterIndex: nextProps.characterIndex,
				theme: nextProps.theme,
				isEuroBraille: nextProps.isEuroBraille,
				numeric: parseInt(nextProps.character),
			},
			() => {
				this.getDots();
			}
		);
	}

	getDots() {
		//get numeric representation of character
		let c = parseInt(this.state.numeric);
		//get boolean if it is eurobraille character or not
		let eurobraille = this.state.isEuroBraille;
		if (eurobraille) {
			//check if a character above possibile display capacity of eurobraille should e rendered
			if (c < 256) {
				let binary = c.toString(2);
				let BinString = this.pad(binary, 8, "0");
				let currentDots = BinString.split("").map(Number);
				this.setState({ dots: currentDots }, () => {
					this.getAccessibilityString(currentDots);
				});
				//if above capacity, render an empty character
			} else {
				this.setState({ dots: defaultDots.euro }, () => {
					this.getAccessibilityString(defaultDots.euro);
				});
			}
		} else {
			//check if a character above possibile display capacity of normal braille character should e rendered

			if (c < 64) {
				let binary = c.toString(2);
				let BinString = this.pad(binary, 6, "0");
				let currentDots = BinString.split("").map(Number);
				this.setState({ dots: currentDots }, () => {
					this.getAccessibilityString(currentDots);
				});
				//if above capacity, render an empty character
			} else {
				this.setState({ dots: defaultDots.default }, () => {
					this.getAccessibilityString(defaultDots.default);
				});
			}
		}
	}

	static getDotsByNumber(number, index, isEuro = false, t, isPartOfMultipleCharacter = false) {
		//get numeric representation of character
		let c = parseInt(number);
		var dotArray = [];
		var dotString = ''
		//get boolean if it is eurobraille character or not
		if (isEuro) {
			//check if a character above possibile display capacity of eurobraille should e rendered
			if (c < 256) {
				let binary = c.toString(2);
				let BinString = binary.length >= 8 ? binary : new Array(8 - binary.length + 1).join("0") + binary;
				dotArray = BinString.split("").map(Number);
			}
		} else {
			//check if a character above possibile display capacity of normal braille character should e rendered

			if (c < 64) {
				let binary = c.toString(2);
				let BinString = binary.length >= 6 ? binary : new Array(6 - binary.length + 1).join("0") + binary;
				dotArray = BinString.split("").map(Number);
			}
		}
		//get String
		for (let i = 0; i < dotArray.length; i++) {
			if (dotArray[i] === 1) {
				if (!dotString.startsWith(t('character.dot'))) {
					dotString += t('character.dot') + " " + (i + 1);
				} else {
					dotString += " " + (i + 1);
				}
			}
		}


		if (dotString === "") {
			dotString = t('character.empty');
		}
		if (isPartOfMultipleCharacter) {
			let key = "character." + (parseInt(index) + 1) + "_char";
			dotString =
				t(key) + " " + dotString;
		}
		return dotString
	}

	getNumeric() {
		let number = parseInt(this.state.dots.join(""), 2);
		this.props.onCharacterChange(number, this.state.characterIndex);
		this.setState({ numeric: number });
	}

	updateDot(i) {
		let dots = this.state.dots;
		if (dots[i] === 0) {
			dots[i] = 1;
		} else {
			dots[i] = 0;
		}
		this.setState({ dots: dots });
		this.getNumeric();
	}

	getAccessibilityString(newDots) {
		const { t } = this.props;

		let accessibilityString = "";
		let dots = newDots;
		for (let i = 0; i < dots.length; i++) {
			if (dots[i] === 1) {
				if (!accessibilityString.startsWith(t('character.dot'))) {
					accessibilityString += t('character.dot') + " " + (i + 1);
				} else {
					accessibilityString += " " + (i + 1);
				}
			}
		}


		if (accessibilityString === "") {
			accessibilityString = t('character.empty');
		}
		if (this.state.isPartOfMultipleCharacter) {
			let key = "character." + (parseInt(this.state.characterIndex) + 1) + "_char";
			accessibilityString =
				t(key) + " " + accessibilityString;
		}
		this.setState({ accessibilityString: accessibilityString });
	}

	componentDidMount() {
		this.setState(
			{
				isReading: this.props.isReading,
				isPartOfMultipleCharacter: this.props.isPartOfMultipleCharacter,
				characterIndex: this.props.characterIndex,
				theme: this.props.theme,
				isEuroBraille: this.props.isEuroBraille,
				numeric: parseInt(this.props.character),
			},
			() => {
				this.getDots();
			}
		);
	}

	getDotViews() {
		let dots = this.state.dots;
		var accessibilityString = "";
		var dotViews = [];
		// create accessibility String for multiple characters
		if (this.state.isPartOfMultipleCharacter) {
			accessibilityString = lang.prefix[this.state.characterIndex];
		}
		//create dot Views
		for (let i = 0; i < dots.length; i++) {
			//Views for a character in reading mode
			if (this.state.isReading) {
				dotViews.push(
					<div className='brailleDotContainer'>
						<div
							className={
								dots[i] === 0
									? 'unfilledDot'
									: 'filledDot'
							}
						></div>
					</div>
				)
			} else {
				dotViews.push(
					<div className='brailleDotContainer' onClick={() => this.updateDot(i)}>
						<div
							role='button'
							aria-label={
								accessibilityString +
								(dots[i] === 1
									? lang.dot + (i + 1) + " " + lang.on
									: lang.dot + (i + 1) + " " + lang.off)
							}
							className={
								dots[i] === 0
									? 'unfilledDot'
									: 'filledDot'
							}
						></div>
					</div>
				)
			}
		}
		return dotViews
	}

	render() {
		let dotViews = this.getDotViews();
		return (
			<Fragment>
				<div
					className='characterContainer'
					aria-label={this.state.isReading ? this.state.accessibilityString : ''}
					aria-level='1'
					role={this.state.isReading ? 'image' : ''}
				>
					<span aria-label={this.state.accessibilityString}></span>
					<div className='HStack'>
						{/* first column of dots 1, 2 and 3*/}
						<div className={'firstRow'}>
							{dotViews[0]}
							{dotViews[1]}
							{dotViews[2]}
						</div>
						{/* second column of dots 4, 5 and 6*/}
						<div className={'secondrow'}>
							{dotViews[3]}
							{dotViews[4]}
							{dotViews[5]}
						</div>
					</div>
					<div className={'HStack'}>
						{dotViews[6]}
						{dotViews[7]}
					</div>
				</div>
				<p></p>
			</Fragment>
		)
	}
}
export default hoistStatics(withTranslation()(BrailleCharacter), BrailleCharacter);